<template>
  <div class="article">
    <h2 class="header">
      <slot></slot>
    </h2>
    <p class="body">
      <slot name="body"></slot>
    </p>
  </div>
</template>

<script>
</script>

<style scoped lang="scss">
.article {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .header {
    color: #404249;
    font-size: rem(16);
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
    margin: 0;
  }

  .body {
    color: #404249;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
    margin: 0;
  }
}
</style>